import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined, // Will be set by AuthProvider
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
  interface RouteContext {
    auth: ReturnType<typeof import('@/features/auth').useAuth>;
  }
}
